import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=3ece4f7e"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ece4f7e')) {
      api.createRecord('3ece4f7e', component.options)
    } else {
      api.reload('3ece4f7e', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=3ece4f7e", function () {
      api.rerender('3ece4f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/Sidebar/SidebarItem.vue"
export default component.exports